import React from 'react';
import { Calendar } from 'lucide-react';
import { Event } from '../types';
import { exportEventToCalendar } from '../utils/calendarExport';

interface AddToCalendarProps {
  event: Event;
  buttonText?: string;
  compact?: boolean;
}

const AddToCalendar: React.FC<AddToCalendarProps> = ({
  event,
  buttonText = 'Add to Calendar',
  compact = false
}) => {
  const handleAddToCalendar = () => {
    exportEventToCalendar(event);
  };

  return (
    <button
      onClick={handleAddToCalendar}
      className={`${
        compact
          ? 'flex items-center text-white bg-theme-cards/80 backdrop-blur-sm hover:bg-theme-cards transition-all px-3 sm:px-4 py-2 rounded-full shadow-lg border border-theme-cards text-sm min-h-[44px]'
          : 'flex items-center px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/20 text-white rounded-lg transition-colors'
      } flex items-center gap-2`}
      title="Add to phone calendar"
    >
      <Calendar size={compact ? 16 : 20} className={compact ? 'sm:mr-2' : ''} />
      {compact ? (
        <span className="hidden sm:inline">Calendar</span>
      ) : (
        <span>{buttonText}</span>
      )}
    </button>
  );
};

export default AddToCalendar;
